import { AuthContextProps } from "../components/auth-context";
import { postData ,putData} from "./core";

export default class TagsApi {
  static uri = "a/accounts/TagsRequest";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  post(tags?: string[]) {
    return postData({
      uri: TagsApi.uri,
      data: { tags},
      context: this.context,
    });
  }
   put( receiptId: string,
    requestUniqueId?: string |undefined) {
    return putData({
      uri: TagsApi.uri,
      data: { receiptId,requestUniqueId},
      context: this.context,
    });
  }
}
